const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const API_CONFIG = {
    BASE_URL: API_BASE_URL,
    ENDPOINTS: {
        AUTH: {
            REGISTER: '/api/accounts/register/',
            LOGIN: '/api/token/',
            ME: '/api/accounts/me/',
            LOGOUT: '/api/logout/',
            PASSWORD_RESET: '/api/accounts/password-reset/',
            PASSWORD_RESET_CONFIRM: '/api/accounts/password-reset-confirm/',
            SSO_VERIFY_AND_LOGIN: '/api/accounts/sso/verify-and-login/',
        },
        SURVEY: {
            LIST: '/api/survey/',
            CREATE: '/api/survey/create/',
            DETAIL: '/api/survey/:id/',
            UPDATE: '/api/survey/:id/update/',
            DELETE: '/api/survey/:id/delete/',
            QUESTIONS: '/api/survey/:id/questions/',
            RESPONSES: '/api/survey/:id/responses/',
            RESULTS: '/api/survey/:id/results/',
        },
        ANALYTICS: {
            GLOBAL_STATS: '/api/analytics/admin-dashboard/',
            RECENT_ACTIVITIES: '/api/analytics/recent-activities/',
            SURVEY_MONTHLY_TREND: '/api/analytics/survey-monthly-trend/',
            GERANT_STATS: '/api/analytics/gerant-stats/',
            RECENT_RESPONSES: '/api/analytics/recent-responses/',
            DASHBOARD_STATS: '/api/analytics/dashboard-stats/',
            RECENT_USERS: '/api/analytics/recent-users/',
        },
        NOTIFICATIONS: {
            BASE: '/api/notifications/notifications',
        },
        AUDIT_LOGS: '/api/audit-logs/',
        USERS: {
            LIST: '/api/accounts/users/',
            STATS: '/api/accounts/users/stats/',
            DETAIL: '/api/accounts/users/',
            EXPORT: '/api/accounts/users/export/',
            CREATE_GERANT: '/api/accounts/gerants/',
        },
        PARTICIPANTS: {
            BASE: '/api/participants',
            LIST: '/api/participants/',
            DETAIL: '/api/participants/',
            SEND_INVITE: '/api/participants/',
            ASSIGN_SURVEY: '/api/participants/',
            PARTICIPATION: '/api/participants/participation/',
            RESPONSES: '/api/participants/participation/',
            TOKEN_VALIDATE: '/api/participants/token/validate/',
            TOKEN_REFRESH: '/api/participants/token/refresh/',
            TOKEN_STATUS: '/api/participants/token/status/',
        },
    },
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
};

export default API_CONFIG;
